<div class="my-2">
	<app-checkbox
		type="clear"
		[ngModel]="firstPageHeader"
		(ngModelChange)="onFirstPageHeaderChange($event)"
		>First page</app-checkbox
	>
</div>
